<template>
  <div class="mt-2">
    <div class="container-fluid">
      <div class="row d-flex justify-content-start">
        <div class="col-12 pl-0 pl-md-2 pt-2 pb-0">
          <SectionTitle
            class="responsive-section-title"
            has-line
            content="Información de Evaluación de Asistencia Tecnológica"
          />
        </div>
      </div>

      <div v-if="evaluations.length == 0" class="row">
        <div class="col-12">
          <CustomResultNotFound class="mt-4" :text="noResultsText" />
        </div>
      </div>

      <div
        v-for="item in evaluations"
        v-else
        :key="item.studentEvaluationId"
        class="row bg-gray mb-3 py-4"
      >
        <div class="col-1 m-md-auto mx-auto text-center">
          <Checkbox
            v-model="item.selected"
            class="justify-content-center"
            :class="noEvaluationSelected ? 'invalid' : ''"
            :has-error="noEvaluationSelected"
            :disabled="readOnly"
            @input="onChange(item)"
          />
        </div>

        <div class="col-md-3 col-5">
          <div class="row">
            <div class="col-12">
              <span class="font-weight-normal">Evaluación:</span>
            </div>
            <div class="col-12">
              <span class="font-weight-regular">
                Asistencia Tecnológica
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-5">
          <div class="row">
            <div class="col-12">
              <span class="font-weight-normal">Fecha:</span>
            </div>
            <div class="col-12">
              <span class="font-weight-regular">
                {{ formatDate(item.evaluationDate) }}
              </span>
            </div>
          </div>
        </div>

        <div class="d-block d-md-none col-2" />

        <div class="col-md-3 col-10 pt-2 pt-md-0">
          <div class="row">
            <div class="col-12">
              <span class="font-weight-normal">Administrada por:</span>
            </div>
            <div class="col-12">
              <span class="font-weight-regular">
                {{ item.evaluationAdministeredBy }}
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="!readOnly"
          class="col-md-2 col-12 text-center my-md-auto pt-2 pt-md-0"
        >
          <DropDown
            :key="item.studentEvaluationId"
            class="d-sm-block"
            :items="getMenuItems(item)"
            normal-size
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <Error
            v-if="noEvaluationSelected"
            variant="no-border"
            :message="getError('R03200042')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomResultNotFound from "custom-result-not-found";
import SectionTitle from "SectionTitle";
import DropDown from "dropdown";
import Checkbox from "CheckBox";
import Error from "custom-error";
import { getATEvaluations } from "@/modules/request-tech-service-assistance/api";
import resourcesService from "@/services/resources.js";
import moment from "moment";
import generalService from "@/services/pei/general";
import documentTypes from "@/utils/constants/documentTypes.js";
import mixAlert from "@/mixin/alert.mixin";

export default {
  name: "ATEvaluationsInformation",
  components: { CustomResultNotFound, SectionTitle, DropDown, Checkbox, Error },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixAlert],
  data() {
    return {
      resources: [],
      evaluations: [],
      readonly: false,
      noEvaluationSelected: false,
      validateDatetoSubmit: true,
      noResultsText: "El estudiante no cuenta con evaluaciones."
    };
  },
  computed: {
    studentSie() {
      return this.$store.getters.SelectedStudent.studentId;
    },
    selectedEvaluation() {
      return this.evaluations.find(x => x.selected);
    }
  },
  methods: {
    getError(code) {
      let message = this.resources[code];

      return message ? message.replace(`(${code})`, "") : "";
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        "R03200042"
      ]);
    },
    async getATEvaluations() {
      await getATEvaluations(this.studentSie).then(({ data }) => {
        data.forEach(x => (x.selected = false));
        this.evaluations = data;
      });
    },
    onChange(item) {
      if (item.selected) {
        this.validateEvaluations();
        this.validateDateEvaluation(item);
        this.evaluations
          .filter(x => x.studentEvaluationId != item.studentEvaluationId)
          .forEach(x => {
            x.selected = false;
          });
      }
    },
    downloadDocument(studentEvaluationId, documentType) {
      documentType = documentType ?? documentTypes.IntitialEvaluation;

      generalService
        .downloadStudentDocument(studentEvaluationId, documentType)
        .then(resp => {
          if (!resp) {
            this.ShowToast(
              "",
              "Aún no se ha subido ningún documento para esta evaluación.",
              "warning"
            );
          }
        })
        .catch(({ response: errors }) => {
          if (errors && errors.data)
            this.ShowToast("", errors.data.errors.errors[0], "error");
        });
    },
    getMenuItems(item) {
      const items = [
        {
          label: "Descargar",
          icon: "fas fa-file-download green-icon",
          visible: item.studentEvaluationId > 0,
          click: () => this.downloadDocument(item.studentEvaluationId)
        }
      ];

      return items;
    },
    formatDate(date) {
      return moment(date).format("DD/MMM/YYYY");
    },
    validateEvaluations() {
      const selectedEvaluation = this.evaluations.find(x => x.selected);
      if (selectedEvaluation) {
        this.noEvaluationSelected = false;
        return true;
      } else {
        this.noEvaluationSelected = true;
        return false;
      }
    },
    validateDateEvaluation(selectedEvaluation) {
      this.validateDatetoSubmit = true;
      const current = moment();
      const evaluationGetedDate = moment(selectedEvaluation.evaluationDate);

      if (current.diff(evaluationGetedDate, "years") >= 5) {
        this.validateDatetoSubmit = false;      
      }

      this.$emit("canSubmit", this.validateDatetoSubmit);
    }
  },
  async mounted() {
    const { id } = this.$route.params;
    if (id == null) {
      await this.getATEvaluations();
      await this.loadResources();
    }
  }
};
</script>

<style scoped>
.invalid >>> span {
  background: #fae7e7 !important;
}

@media (max-width: 765px) {
  .d-sm-block >>> button {
    width: 100%;
  }

  .responsive-section-title >>> .tag-badge-title-info {
    font-size: 0.8rem;
  }
}
</style>
